
// --------------------------------- ドイツの愛らしいグリーティングカードポップアップ ---------------------------------

const giftLovelyCardBtn = document.getElementById("giftLovelyCardBtn");
if(giftLovelyCardBtn){
  const giftLovelyCardPop = document.getElementById("giftLovelyCardPop");
  const giftLovelyCardPopClose = document.getElementById("giftLovelyCardPopClose");
  const giftLovelyCardPopIn = document.getElementById("giftLovelyCardPopIn");
  giftLovelyCardBtn.addEventListener("click", function(e) {
    e.preventDefault();
    fadeIn(giftLovelyCardPop, 200, "flex");
  });
  giftLovelyCardPopClose.addEventListener("click", function(e) {
    fadeOut(giftLovelyCardPop, 200);
  });
  giftLovelyCardPop.addEventListener("click", function(e) {
    fadeOut(giftLovelyCardPop, 200);
  });
  giftLovelyCardPopIn.addEventListener("click", function(e) {
    e.stopPropagation();
  });
}

// --------------------------------- 商品画像スライド ---------------------------------

//商品画像スライダー化  
$(".product-grid-item__image_slide").slick({
  autoplay: false,
  speed: 800,
  dots: true,
  arrows: false,
  centerMode: true,
  centerPadding: '0',
  variableWidth: false
});
//非表示タブ内のスライダーを表示時に初期化
$('.mb-gift__tab-input').on('change', function (e){
  $('.product-grid-item__image_slide').slick('setPosition');
});
$('.mb-gift__tab-input').on('change', function (e){
  $('.product-grid-item__image_slide').slick('setPosition');
});
$(".product-grid-item__image_slide").on('click', 'button', function (e) {
  e.stopPropagation();
});

// --------------------------------- メッセージカード周り ---------------------------------

//Dear, From
$(`[name="messageDear"]`).on("input", function(){
  let dear = $(this).val();
  //プレビューに反映
  const target = $(this).attr("data-preview-target");
  $(`.dear[data-preview-name="${target}"]`).text(dear);
});
$(`[name="messageFrom"]`).on("input", function(){
  let from = $(this).val();
  //プレビューに反映
  const target = $(this).attr("data-preview-target");
  $(`.from[data-preview-name="${target}"]`).text(from);
});

//文字数ごとに区切りを入れる関数
function addLineBreaks(str, maxCharCount, lineCode) {
  const regex = new RegExp(`.{1,${maxCharCount}}`, 'g');
  return str.match(regex).join(lineCode);
}

//入力文字数・行ごとの文字数・行数を制限・プレビューに反映
let msgTextBefore = "";
$(".mb_msg_card_textarea").on("beforeinput", function(e){
  msgTextBefore = $(this).val();
});
$(".mb_msg_card_textarea").on("input", function(e){
  e.preventDefault();
  //入力されたテキスト
  let message = $(this).val();
  //改行数をオーバーした場合の処理
  let maxLine = $(this).attr("data-max-line");
  if(maxLine){
    maxLine = Number(maxLine);
  }else{
    maxLine = 5;
  }
  const regex = /\r?\n/g;
  const matches = [...message.matchAll(regex)];
  if (matches.length >= maxLine) {
    //行数オーバーしたテキストを削るパターン
    //const targetIndex = matches[maxLine - 1].index;
    //message = message.slice(0, targetIndex);
    //行数オーバーした場合は、入力前のテキストに戻して改行を受け入れない
    message = msgTextBefore;
  }
  //文字数オーバーした場合は削る
  const maxLength = Number($(this).attr("maxLength"));
  if (message.length > maxLength) {
    message = message.slice(0, maxLength);
  }
  //1行あたりの文字数制限（指定がなければ22文字）
  let lengthPerLine = $(this).attr("data-length-per-line");
  if(lengthPerLine){
    lengthPerLine = Number(lengthPerLine);
  }else{
    lengthPerLine = 22;
  }
  //規定以上の場合は改行を入れる
  const msgLineArray = message.split(/\r?\n/g);
  let newLinedMsg = "";
  msgLineArray.forEach(function(msg, index){
    if(msg.length > lengthPerLine){
      if(index > 0){
        newLinedMsg += '\n';
      }
      newLinedMsg += addLineBreaks(msg, lengthPerLine, '\n');
    }else{
      if(index > 0){
        newLinedMsg += '\n';
      }
      newLinedMsg += msg;
    }
  });
  //整えたテキストを textarea に戻す
  $(this).val(newLinedMsg);
  //プレビューに反映
  const previewMessage = newLinedMsg.replaceAll('\n','<br>');
  const target = $(this).attr("data-preview-target");
  $(`.messageCardPreview-body[data-preview-name="${target}"]`).html(previewMessage);
});

// --------------------------------- footer張り付きのステップ表示関連 ※コードが長すぎる ---------------------------------

//クリックでそのセクションにスクロール
let steps = document.getElementsByClassName("mb-gift__footer-step");
if(steps.length > 0){

  Array.from(steps).forEach(function(step) {
    step.addEventListener("click", function() {
      let stepTarget = step.getAttribute("for");
      if (stepTarget) {
        let targetElem = document.getElementById(stepTarget);
        if (targetElem) {
          let position = targetElem.getBoundingClientRect();
          window.scrollTo({
            top: position.top + window.scrollY - 80,
            behavior: "smooth"
          });
        }
      }
    });
  });

  //項目を選択されたら文字色を濃く
  let productStep = document.querySelector(".mb-gift__footer-step[for=gift-step-product]");
  let productActions = document.getElementsByClassName("gift-step-action-product");
  Array.from(productActions).forEach(function(productAction) {
    productAction.addEventListener("change", function() {
      productStep.classList.toggle("unselected", false);
    });
  });

  let wrappingStep = document.querySelector(".mb-gift__footer-step[for=gift-step-wrapping]");
  let wrappingActions = document.getElementsByClassName("gift-step-action-wrapping");
  Array.from(wrappingActions).forEach(function(wrappingAction) {
    wrappingAction.addEventListener("change", function() {
      wrappingStep.classList.toggle("unselected", false);
    });
  });

  let optionsStep = document.querySelector(".mb-gift__footer-step[for=gift-step-option]");
  let optionsActions = document.getElementsByClassName("gift-step-action-options");
  Array.from(optionsActions).forEach(function(optionsAction) {
    optionsAction.addEventListener("change", function() {
      optionsStep.classList.toggle("unselected", false);
    });
  });

}

/* ------------------------------- ギフトバッグのスライダーと使用上の注意ポップアップ ------------------------------- */

//ギフトバッグのスライダー
$('.mb-gift__giftbag_images').slick({
  arrows: false,
  dots: true,
  autoplay: true
});

//使用上の注意ポップアップ
$(".gift_notice_popup_open").on('click',function(e){
  e.stopPropagation();
  e.preventDefault();
  $(".gift_notice_popup").fadeIn(300);
});
$(".gift_notice_popup_close").on('click',function(e){
  e.preventDefault();
  $(".gift_notice_popup").fadeOut(300);
});

/* ------------------------------- カート追加完了後にギフトバッグのカート追加を行う ------------------------------- */

function doAfterAddedCartForGift(json){
  var hasGiftBag = json["properties"]["has-giftbag"];
  console.log("hasGiftBag: ", hasGiftBag);
  if(hasGiftBag == 'yes'){
    //URLハンドル指定で商品データの variant idを取得する（js.liquid だと liquid の all_products[] が使えないので仕方なく ajax で取得）
    $.getJSON('/products/gift-bag.js', function(giftbagJson) {
      var giftbagVariantId = giftbagJson["variants"][0]["id"];
      console.log("giftbagVariantId", giftbagVariantId);
      var data = {
        items: [ { id: giftbagVariantId, quantity: 1 } ]
      };
      //Ajaxでギフトバッグをカート追加。特に通知はしない。
      $.post({
        url:  '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: data,
      }).done(function(data, textStatus, jqXHR){
        console.log("ギフトバッグ追加完了");
      }).fail(function(jqXHR, textStatus, errorThrown){
        //console.log("失敗: "+JSON.stringify(jqXHR));
        //console.log("失敗: "+textStatus);
        //console.log("失敗: "+errorThrown);
        console.log("ギフトバッグ追加失敗");
      });
    });
  }
}
